export const tripDetails = {
  destination: "NEO-TOKYO, JP",
  subtitle: "Cyberpunk City Break",
  dates: "OCT 12 - OCT 19, 2024",
  flight: "JL 007",
  gate: "G-42",
  seat: "12A",
  class: "BUSINESS",
  status: "ON TIME",
  progress: 65,
  weather: { temp: "22°", condition: "Neon Rain", humidity: "78%" },
  metrics: [
    { label: "ITINERARY LOAD", value: "24 Events" },
    { label: "RESERVATIONS", value: "8 Active" },
    { label: "AVG WALKING", value: "14.2 km" },
    { label: "BUDGET HEALTH", value: "Nominal" }
  ]
};

export const budgetData = {
  total: 4500,
  spent: 2940,
  currency: "USD",
  categories: [
    { name: "Flights", value: 1200, color: "#00F0FF", trend: "up" },
    { name: "Accommodation", value: 850, color: "#00C3CF", trend: "stable" },
    { name: "Food & Dining", value: 480, color: "#FF6B6B", trend: "down" },
    { name: "Activities", value: 410, color: "#E55A5A", trend: "up" }
  ]
};

export const timelineData = [
  { day: "DAY 1", date: "OCT 12", events: [
    { id: 1, time: "14:00", title: "Arrival at HND", type: "transit", location: "Haneda Airport Terminal 3", status: "confirmed" },
    { id: 2, time: "15:30", title: "Hyper-Express Train", type: "transit", location: "Monorail Line 4", status: "confirmed" },
    { id: 3, time: "16:30", title: "Check-in: Shinjuku Pods", type: "hotel", location: "Kabukicho District", status: "confirmed" },
    { id: 4, time: "19:00", title: "Neon District Walk", type: "activity", location: "Omoide Yokocho", status: "pending" }
  ]},
  { day: "DAY 2", date: "OCT 13", events: [
    { id: 5, time: "09:00", title: "Tech Market Tour", type: "activity", location: "Akihabara Electric Town", status: "confirmed" },
    { id: 6, time: "13:00", title: "Sushi Synthesizer Lunch", type: "food", location: "Ginza Sky Building", status: "confirmed" }
  ]}
];

export const placesData = [
  { id: 1, name: "Shibuya Crossing", type: "Landmark", rating: 4.9, reviews: 1240, img: "https://images.unsplash.com/photo-1542051812871-7575015c058e?auto=format&fit=crop&q=80&w=800" },
  { id: 2, name: "Senso-ji Temple", type: "Culture", rating: 4.8, reviews: 850, img: "https://images.unsplash.com/photo-1531737212413-667205e1cda7?auto=format&fit=crop&q=80&w=800" },
  { id: 3, name: "Akihabara District", type: "Shopping", rating: 4.7, reviews: 2100, img: "https://images.unsplash.com/photo-1580988636752-658b43bd110b?auto=format&fit=crop&q=80&w=800" }
];

export const packingList = [
  { category: "Tech Gear", items: [{ name: "Universal Adapter", checked: true }, { name: "Power Bank 20k", checked: true }, { name: "Noise Cancelling Pods", checked: false }] },
  { category: "Essential Wear", items: [{ name: "Rain Shell", checked: true }, { name: "Walking Sneakers", checked: false }] }
];

export const demoWorkflow = [
  { id: '1', title: 'Mission Genesis', icon: 'FiPlusCircle', desc: 'Define your destination and travel persona (Work, Solo, or Explorer).' },
  { id: '2', title: 'AI Lane Synthesis', icon: 'FiCpu', desc: 'Proprietary algorithms compute optimal paths avoiding transit friction.' },
  { id: '3', title: 'Timeline Sequencing', icon: 'FiClock', desc: 'Drag-and-drop events into chronological lanes for a seamless flow.' },
  { id: '4', title: 'Financial Orbit', icon: 'FiPieChart', desc: 'Track multi-currency expenses with real-time budget limit alerts.' },
  { id: '5', title: 'Offline Compression', icon: 'FiDownloadCloud', desc: 'Package maps and docs into an encrypted local cache for no-signal zones.' },
  { id: '6', title: 'Group Broadcast', icon: 'FiShare2', desc: 'Generate encrypted shareable links for synchronized group logistics.' },
  { id: '7', title: 'Final Arrival', icon: 'FiCheckCircle', desc: 'Execute the plan with real-time status updates and gate changes.' }
];

export const sampleRecords = [
  { id: 'REC-001', type: 'Booking', name: 'Shinjuku Pod Hotel', status: 'Confirmed', date: 'Oct 12', value: '$850.00' },
  { id: 'REC-002', type: 'Transit', name: 'JL-007 Flight', status: 'On Time', date: 'Oct 12', value: 'Gate G42' },
  { id: 'REC-003', type: 'Activity', name: 'Robot Cafe VIP', status: 'Pending', date: 'Oct 13', value: '$45.00' },
  { id: 'REC-004', type: 'Food', name: 'Sushi Ginza', status: 'Waitlist', date: 'Oct 13', value: '20:00' },
  { id: 'REC-005', type: 'Sync', name: 'Offline Maps JP', status: 'Success', date: 'Oct 11', value: '1.2 GB' }
];

export const faqData = [
  { q: "How does the offline sync work?", a: "RouteMuse compresses your itinerary, maps, and tickets into a local JSON database. Once synced, the app operates entirely without cellular data." },
  { q: "Is this suitable for corporate travel?", a: "Absolutely. We offer 'Work/Life' personas that prioritize high-speed Wi-Fi zones, co-working proximity, and airport lounge access." },
  { q: "How secure is the plan sharing?", a: "Sharing links are end-to-end encrypted. Only recipients with the secure handshake can view live location or booking details." },
  { q: "Does the AI require a subscription?", a: "The core 'Lane Synthesis' is free for individual trips. Enterprise-grade fleet coordination requires a Pro Access pass." },
  { q: "Can I import existing bookings?", a: "Yes, our system parses airline and hotel confirmation emails automatically to populate your timeline lanes." }
];